export const ERROR = {
  SOMETHING_WRONG: 'Something went wrong.',
  FETCH_USERS: 'Error fetching users',
  FETCH_COURIERS: 'Error fetching couriers',
  FETCH_ACCOUNTS: 'Error fetching accounts',
  FETCH_BRANDS_INFO: 'Error fetching brands info',
  FETCH_CAPACITY_INFO: 'Error fetching capacity info',
  FETCH_ROLES_BACKEND: 'Could not fetch roles from backend',
  UPDATE_STORE_SETTINGS: 'Error updating store settings',
  COULDNT_UPDATE_STORE_SETTINGS: 'The store settings could not be updated',
  ACCOUNTS_NOT_FOUNDS: 'No accounts found.',

  SHIFT_NO_ANSWER: 'You have not answered anything',
  SHIFT_NOT_SIGNED_UP: 'You have not signed up for work!',
  SHIFT_WORK_DECLINED: 'You have declined the work!',

  SHIFT_CHANGE: `Failed to apply changes. Please try again`,
  SHIFT_CREATE: `Failed to create shift(s). Please try again`,
  SHIFT_CREATE_OPEN_SPOT: `Failed to create open shift. Please try again`,
  SHIFT_COPY: `Failed to copy shifts. Please try again`,
  SHIFT_FETCH: `Failed to fetch shifts`,
  SHIFT_DELETE: `Failed to remove shift(s). Please try again`,
  SHIFT_STATUS_UPDATE: `Failed to update shift. Please try again`,
  SHIFT_NOTE_UPDATE: `Failed to update note. Please try again`,
  SHIFT_PUBLISH: `Failed to publish shifts. Please try again`,
  SHIFT_FETCH_WISH: `Failed to fetch wish couriers`,
  SHIFT_FETCH_EFFICIENCY: `Failed to fetch couriers efficiency data`,
};
